import renderInputField from 'components/FormControls/textInput'
import { Button, Typography } from 'gu-ui-kit'
import PropTypes from 'prop-types'
import React, { useCallback } from 'react'
import { useTranslation } from 'react-i18next'
import { useDispatch } from 'react-redux'
import { Field, Form, reduxForm } from 'redux-form'
import validator from 'utils/asyncValidator'
import shouldAsyncValidate from 'utils/shouldAsyncValidate'
import * as Yup from 'yup'
import formStyles from 'modules/Forms/common-form.module.scss'
import styles from 'modules/User/Security/Security.module.scss'
import { Link } from 'react-router-dom'
import { ROUTES } from 'constants/routes'
import useGeneratePathI18n from 'utils/hooks/useGeneratePathI18n'
import { useHistory } from 'react-router'
import { onlyNumbers } from 'utils/normalize/onlyNumbers'
import { DISABLE_2FA, GET_2FA } from 'modules/User/Security/2fa/types'

const validationSchema = Yup.object().shape({
  password: Yup.string().required('common::validation_messages.required'),
  code: Yup.string().required('common::validation_messages.required'),
})

let Disable2FA = ({ handleSubmit, submitting, form }) => {
  const { t } = useTranslation()
  const dispatch = useDispatch()
  const pathGen = useGeneratePathI18n()
  const history = useHistory()

  const submit = useCallback(
    (values) =>
      new Promise((resolve, reject) => {
        dispatch({
          //TODO пробросим промис колбэки в сагу
          meta: { resolve, reject },
          type: DISABLE_2FA,
          payload: { data: values, formName: form },
        })
      }).then(() => {
        history.push(pathGen(ROUTES.USER_SECURITY_2FA))
        dispatch({ type: GET_2FA })
      }),
    [dispatch, form],
  )

  return (
    <>
      <Typography variant={'h1'} className={styles['security__heading']}>
        {t('user::security.2fa.disable_form.heading')}
      </Typography>
      <Form onSubmit={handleSubmit(submit)} id="2fa-disable">
        <div className={'margin-bottom-16'}>
          <Field
            fullWidth
            name="password"
            type={'password'}
            autoComplete="off"
            component={renderInputField}
            t={t}
            placeholder={t('user::security.2fa.enable_form.password.placeholder')}
            label={t('user::security.2fa.enable_form.password.placeholder')}
            cleanButton
            revealButton
          />
        </div>
        <div className={'margin-bottom-40'}>
          <Field
            fullWidth
            name="code"
            type="text"
            inputMode="numeric"
            component={renderInputField}
            normalize={onlyNumbers}
            maxLength={6}
            autoComplete="off"
            t={t}
            placeholder={t('user::security.2fa.disable_form.code.placeholder')}
            label={t('user::security.2fa.disable_form.code.placeholder')}
            cleanButton
          />
        </div>

        <div className={formStyles['formControl__action-buttons']}>
          <Button
            disabled={submitting}
            component={Link}
            to={pathGen(ROUTES.USER_SECURITY_2FA)}
            variant={'ghost'}
            grey
          >
            {t('common::form_buttons.cancel')}
          </Button>

          <Button
            disabled={submitting}
            size="l"
            variant="primary"
            type="submit"
            bgColor="Label-GU-Primary"
            form="2fa-disable"
          >
            {t('user::security.2fa.disable_form.submit')}
          </Button>
        </div>
      </Form>
    </>
  )
}

Disable2FA = reduxForm({
  form: 'Disable2FA',
  updateUnregisteredFields: true,
  enableReinitialize: true,
  initialValues: {
    password: '',
    code: '',
  },
  shouldAsyncValidate: shouldAsyncValidate,
  asyncValidate: validator(validationSchema),
})(Disable2FA)

Disable2FA.propTypes = {
  handleSubmit: PropTypes.func,
  submitting: PropTypes.bool,
  form: PropTypes.string,
  onCancel: PropTypes.func,
}

export default Disable2FA
